import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setDialog } from "../../../features/dialog/dialogSlice";
import { useGetFileDataByIdQuery } from "../../../features/fileData/fileDataApiSlice";
import Loading from "../../../components/spinners/Loading";

function PreviewDocumentView() {
  const { fileId } = useParams();
  const dispatch = useDispatch();

  const {
    data: fileData,
    isLoading,
    isFetching,
  } = useGetFileDataByIdQuery(fileId);

  // Ensure fileData is an object and not an array
  const file = fileData && typeof fileData === "object" ? fileData : null;

  useEffect(() => {
    if (fileId && file) {
      dispatch(
        setDialog({
          title: "Datei anzeigen",
          type: "CREATE",
          content: "file-show",
          redirect: "/",
          data: {
            fileData: { _id: fileId, ...file }, // Ensure file object is valid
            action: "CONFIRMATION",
          },
        })
      );
    }
  }, [fileId, file, dispatch]); // ✅ Runs only when file is available

  // Show loading spinner while fetching
  if (isLoading || isFetching) {
    return <Loading backdrop={true} />;
  }

  return file ? <div>Dokumentenvorschau</div> : <div>Datei nicht gefunden</div>;
}

export default PreviewDocumentView;
